import {createSlice} from "@reduxjs/toolkit";

const initialReportAbuseState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  reportAbuseForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const reportAbuseSlice = createSlice({
  name: "reportAbuse",
  initialState: initialReportAbuseState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getProductById
    reportAbuseFetched: (state, action) => {
      state.actionsLoading = false;
      state.reportAbuseForEdit = action.payload.reportAbuseForEdit;
      state.error = null;
    },
    // findReportAbuse
    reportAbuseListFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createProduct
    reportAbuseCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.reportAbuse);
    },
    // updateProduct
    reportAbuseUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.reportAbuse.id) {
          return action.payload.reportAbuse;
        }
        return entity;
      });
    },
    // deleteProduct
    reportAbuseDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteReportAbuse
    reportAbuseDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // reportAbuseUpdateState
    reportAbuseStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
